import Assignments from 'Pages/Admin/Services/Assignments';
import Forms from 'Pages/Admin/Services/Forms';

export default [
    {path: '/admin/services/assignments', component: Assignments, guards: ['auth', 'two-factor-verified', 'can-manage-services']},
    {path: '/admin/services/forms', component: Forms, guards: ['auth', 'two-factor-verified', 'can-manage-services']},
];
